// @ts-strict-ignore
import React from 'react';
import { sprintf } from 'sprintf-js';

import { Box } from 'components/Box';
import { AvatarImage } from 'components/Image';
import { ConditionalLink } from 'components/Link';
import { Body, H4, Text } from 'components/Text';
import { colors } from 'theme';
import { humanDateTime } from 'utils/date';

type Props = {
  slug?: string;
  name?: string;
  imageHandle?: string | null | undefined;
  homePageUrl?: string;
  postedDate: string;
  showDate: boolean;
  small?: boolean;
};

export function Byline({
  slug,
  name,
  imageHandle,
  homePageUrl,
  postedDate,
  showDate,
  small,
}: Props) {
  return (
    <Box classes={['flex', 'align-center']} data-qa-id="byline" flex="2">
      {imageHandle && (
        <AvatarImage
          data-qa-id="byline-image"
          alt={sprintf(getText('%(name)s profile image'), {
            name,
          })}
          handle={imageHandle}
          width={60}
          round
          mr={3}
        />
      )}
      <Box>
        {name && (
          <H4 data-qa-id="author-name" m={0} lineHeight={1}>
            <ConditionalLink
              data-qa-id="author-name-link"
              link={
                homePageUrl && slug
                  ? `/${homePageUrl}?author.slug=${slug}&pq=`
                  : ''
              }
            >
              <Body styleAs={small && 'bodySmall'} lineHeight={1.33}>
                {name}
              </Body>
            </ConditionalLink>
          </H4>
        )}
        {showDate && (
          <Text
            tag="time"
            // @ts-expect-error Fix type
            dateTime={postedDate}
            color={colors.battleshipGrey}
            styleAs={small ? 'bodyMicro' : 'bodySmall'}
          >
            {humanDateTime(postedDate)}
          </Text>
        )}
      </Box>
    </Box>
  );
}
